import gql from 'graphql-tag'

import { PublicExpoUpdateRegistrationMutation } from '../../../types/api'

// todo : add opt
export const updateRegistration = {
  mutation: gql`
    mutation publicExpoUpdateRegistration($eventSlot: ID!, $optinRegistration: Boolean) {
      publicExpoUpdateRegistration(eventSlot: $eventSlot, optinRegistration: $optinRegistration) {
        id
        first_name
        last_name
        email
        checked_in_at
      }
    }
  `,
  transformer: (response: PublicExpoUpdateRegistrationMutation) => {
    return response.publicExpoUpdateRegistration
  },
}
